import { ShoppingCartService } from './../../shared/services/shopping-cart.service';
import { Custom } from './../../../modals/createorderautoorder.modal';
import { cloneDeep } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { CartService } from '../../shared/services/cart.service';
import { Observable, of, pipe } from 'rxjs';
import { CartItem } from 'src/app/modals/cart-item';
import { ProductService } from '../../shared/services/product.service';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { Cart1Service } from '../../shared/services/cart1.service';
import { OrderService } from '../../shared/services/order.service';
import { PaymentService } from '../../shared/services/payment.service';
import { UserService } from '../../shared/services/user.service';
import { CouponInfo, UserServiceModal } from 'src/app/modals/userservice.modal';
import * as _ from 'lodash';
import { NotificationService } from '../../shared/services/notification.service';
import { RestApiService } from '../../shared/services/restapi.service';
import { UtilityService } from '../../shared/services/utility.service';
import * as moment from 'moment';
import { ConfigService } from '../../shared/services/config.service';
import { CreateAutoOrder, CreateOrder, CreateOrderAndAutoShip, Item, OrderShippingAddress, Payment, ShippingAddress } from 'src/app/modals/createorderautoorder.modal';
import { ShipAddress } from 'src/app/modals/autoship.modal';
import { OrderCreditCard } from 'src/app/modals/enrollment.model';
import { OrderPipe } from 'ngx-order-pipe';
import { ConfirmDialogComponent } from '../../shared/model/confirm-dialog/confirm-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AddSymbolWithNumberPipe } from '../../shared/pipes/add-symbol-with-number.pipe';
import { ItemsListService } from '../../shared/services/itemsList.service';
import { PersistentService } from '../../shared/services/persistent.service';
import { AccountService } from '../../shared/services/account.service';
import { AllowCvvComponent } from '../../shared/model/allow-cvv/allow-cvv.component';
import { AutoshipConfigurationService } from '../../shared/services/autoshipConfiguration.service';
import { CompanyService } from '../../shared/services/company.service';
import { HostedpaymentDialogComponent } from '../../shared/model/hostedpayment-dialog/hostedpayment-dialog.component';
import { CORPORATESTOREID, DefaultCountry } from 'src/app/constant';
import { ShippingMethodService } from '../../shared/services/shipping-method.service';
import { LoaderService } from '../../shared/services/loader.service';
@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

  public cartItems: Observable<CartItem[]> = of([]);
  public buyProducts: CartItem[] = [];
  public commonData: any;
  removable = true;
  amount: number;
  payments: string[] = ['Create an Account?', 'Flat Rate'];
  paymantWay: string[] = ['Direct Bank Transfer', 'PayPal'];
  OrderQuantityCount: number = 10;
  public AutoOrdersData: any[] = [];
  selectedAutoship: any;
  AutoshipEditFlag: boolean = false;
  createOrderRequest: CreateOrderAndAutoShip;
  userService: UserServiceModal;
  selectedshipmethod: any = 1;
  isStateRestrict: boolean = false;
  isDisabledCreateOrder: boolean = false;
  rewardBalance: number = 0;
  rewardError: string = '';
  UseWalletToPayRemainder: boolean = false;
  autoshipId: any;
  ewalletBalance: number = 0;
  isShowEwalletBalance: boolean = false;
  isFirstOrder: boolean = false;  // Flag to track if this is customer's first order (for free shipping)
  constructor(
    public notificationService: NotificationService,
    public user: UserService,
    private titleService: Title,
    public paymentService: PaymentService,
    public translate: TranslateService,
    public cart1Service: Cart1Service,
    public orderService: OrderService,
    private cartService1: CartService,
    public itemsService: ProductService,
    public apiService: RestApiService,
    public utilityService: UtilityService,
    public configService: ConfigService,
    private dialog: MatDialog,
    private router: Router,
    private orderPipe: OrderPipe,
    public itemsListService: ItemsListService,
    public persistentService: PersistentService,
    public accountService: AccountService,
    public autoshipConfigurationService: AutoshipConfigurationService,
    public companyService: CompanyService,
    public shoppingCartService: ShoppingCartService,
    public route: ActivatedRoute,
    private shippingMethodService: ShippingMethodService,
    private loader: LoaderService
  ) {
    this.userService = this.user.userServiceModal;
    this.commonData = this.configService.getConfig();
    this.route.queryParams.subscribe(params => {
      const id = params['autoshipId'];
      this.autoshipId = id;
    });
    
    if (this.utilityService.getAutoshipEditFlag() && this.persistentService.retailData.CurrentSelectedAutoOrder) {
      this.autoshipId = this.persistentService.retailData.CurrentSelectedAutoOrder;
    }
  }

  ngOnInit() {
    // Store enrollment status BEFORE clearing sessionStorage
    // This ensures we capture the enrollment state for free shipping logic
    const wasEnrollment = this.utilityService.isEnrollment();
    sessionStorage.setItem('IsEnrollment', null);

    // If this was an enrollment flow, ensure the first order flag is set
    if (wasEnrollment) {
      this.isFirstOrder = true;
      this.orderService.setFirstOrderFlag(true);
    }

   
    if (!this.autoshipId &&
        !this.persistentService.retailData.CurrentSelectedAutoOrder &&
        this.itemsService.selectedAutoOrderItems.length === 0 &&
        !this.persistentService.retailData.AddMoreItemInAutoshipFlag) {
      this.utilityService.setAutoshipEditFlag(false);
    }

    this.orderService.getstoreId();
    this.translate.get('global_Company_Title').subscribe((text: string) => {
      this.titleService.setTitle(this.translate.instant('pagetitle_checkout') + ' | ' + text);
    });
    this.cartItems = this.cartService1.getItems();
    this.cartItems.subscribe(products => this.buyProducts = products);
    this.getTotal().subscribe(amount => this.amount = amount);
    this.persistentService.retailData.isNewAutoship = this.persistentService.retailData.isNewAutoship || true;
    this.selectedAutoship = this.persistentService.retailData.CurrentSelectedAutoOrder;
    
    if (this.utilityService.getAutoshipEditFlag()) {
      if (!this.autoshipId) {
        this.autoshipId = this.persistentService.retailData.CurrentSelectedAutoOrder || this.getCurrentAutoshipId();
      }
      if (this.autoshipId && this.autoshipId !== 0 && this.persistentService.retailData.CurrentSelectedAutoOrder === 0) {
        this.persistentService.retailData.CurrentSelectedAutoOrder = this.autoshipId;
      }
    }
    if ((this.itemsService.selectedPacks.length + this.itemsService.selectedOrderItems.length + this.itemsService.selectedAutoOrderItems.length <= 0) && (!this.utilityService.getAutoshipEditFlag())) {
      this.notificationService.error('message_', 'your_order_cart_empty_select_atleast_one_item');
      this.router.navigate(['/products/all']);
    }

    const resolvedAutoOrderId = this.autoshipId || this.persistentService.retailData.CurrentSelectedAutoOrder || this.getCurrentAutoshipId();
    if (this.utilityService.getAutoshipEditFlag() && resolvedAutoOrderId && resolvedAutoOrderId !== 0) {
      if (this.userService.isEditAutoshipAddressChanged && this.userService.shippingAddress && this.userService.shippingAddress.Street1) {
        this.persistentService.retailData.AutoOrderShippingAddress = {
          ShipTo: this.userService.shippingAddress.FullName?.trim() ||
            ((this.userService.shippingAddress.FirstName && this.userService.shippingAddress.LastName) ? `${this.userService.shippingAddress.FirstName} ${this.userService.shippingAddress.LastName}`.trim() : ''),
          FirstName: this.userService.shippingAddress.FirstName || '',
          LastName: this.userService.shippingAddress.LastName || '',
          Address: this.userService.shippingAddress.Street1 || '',
          Address2: this.userService.shippingAddress.Street2 || '',
          Address3: this.userService.shippingAddress.Street3 || '',
          City: this.userService.shippingAddress.City || '',
          State: this.userService.shippingAddress.Region || '',
          Country: this.userService.shippingAddress.CountryCode || '',
          ZipCode: this.userService.shippingAddress.PostalCode || ''
        };
        this.persistentService.setRetailData();
      } else if (!this.persistentService.retailData.AutoOrderShippingAddress || 
          this.utilityService.isEmptyObject(this.persistentService.retailData.AutoOrderShippingAddress) ||
          (!this.persistentService.retailData.AutoOrderShippingAddress.Address && !this.persistentService.retailData.AutoOrderShippingAddress.Street1)) {
        this.loadAutoshipShippingAddress(resolvedAutoOrderId);
      } else {
        if (this.userService.isEditAutoshipAddressChanged && this.userService.shippingAddress && this.userService.shippingAddress.Street1) {
          this.persistentService.retailData.AutoOrderShippingAddress = {
            ShipTo: this.userService.shippingAddress.FullName?.trim() ||
              ((this.userService.shippingAddress.FirstName && this.userService.shippingAddress.LastName) ? `${this.userService.shippingAddress.FirstName} ${this.userService.shippingAddress.LastName}`.trim() : ''),
            FirstName: this.userService.shippingAddress.FirstName || '',
            LastName: this.userService.shippingAddress.LastName || '',
            Address: this.userService.shippingAddress.Street1 || '',
            Address2: this.userService.shippingAddress.Street2 || '',
            Address3: this.userService.shippingAddress.Street3 || '',
            City: this.userService.shippingAddress.City || '',
            State: this.userService.shippingAddress.Region || '',
            Country: this.userService.shippingAddress.CountryCode || '',
            ZipCode: this.userService.shippingAddress.PostalCode || ''
          };
          this.persistentService.setRetailData();
        } else {
          if (this.userService.customerData.DefaultShippingAddress && !this.utilityService.isEmptyObject(this.userService.customerData.DefaultShippingAddress)) {
            this.user.setShippingAddress();
          }
          this.updateAddressWithAutoshipAddress();
        }
      }
    } else {
      if (this.userService.customerData.DefaultShippingAddress && !this.utilityService.isEmptyObject(this.userService.customerData.DefaultShippingAddress)) {
        this.user.setShippingAddress();
      }
    }
    if(this.userService.customerData?.CustomerId){
      this.getCustomerRewardPoints(this.userService.customerData.CustomerId);
      // Fetch fresh customer data to get the latest OrderCount for first order determination
      this.fetchCustomerDataAndCheckFirstOrder();
    } else if (this.utilityService.isEnrollment()) {
      // Enrollment flow - this is always a first order
      this.isFirstOrder = true;
      this.orderService.setFirstOrderFlag(true);
    } else {
      // New customer (retail checkout without login) - default to false until we know for sure
      this.isFirstOrder = false;
      this.orderService.setFirstOrderFlag(false);
    }

    // Check if address was changed - use shippingAddress directly if it's already set with valid data
    // This handles cases where newshippingAddress might not be fully populated but shippingAddress is
    const hasValidShippingAddress = this.userService.shippingAddress && this.userService.shippingAddress.Street1 && this.userService.shippingAddress.PostalCode;
    const hasValidNewShippingAddress = this.userService.newshippingAddress && (this.userService.newshippingAddress.Street1 || this.userService.newshippingAddress.Address) && (this.userService.newshippingAddress.PostalCode || this.userService.newshippingAddress.ZipCode);

    if (this.userService.isAddressChanged && (hasValidNewShippingAddress || hasValidShippingAddress)) {
      if (this.utilityService.getAutoshipEditFlag()) {
        if (this.userService.isEditAutoshipAddressChanged) {
          if (hasValidNewShippingAddress) {
            this.userService.newshippingAddress.FullName = ((this.userService.newshippingAddress.FirstName || '') + ' ' + (this.userService.newshippingAddress.LastName || '')).trim();
            this.userService.shippingAddress = cloneDeep(this.userService.newshippingAddress);
          }
        } else {
          if (this.persistentService.retailData.AutoOrderShippingAddress && !this.utilityService.isEmptyObject(this.persistentService.retailData.AutoOrderShippingAddress)) {
            this.updateAddressWithAutoshipAddress();
          }
        }
      } else {
        // For one-time orders: use newshippingAddress if available, otherwise keep existing shippingAddress
        if (hasValidNewShippingAddress) {
          this.userService.newshippingAddress.FullName = ((this.userService.newshippingAddress.FirstName || '') + ' ' + (this.userService.newshippingAddress.LastName || '')).trim();
          this.userService.shippingAddress = cloneDeep(this.userService.newshippingAddress);
        }
        // If only shippingAddress is valid (already set), don't overwrite it - it's already correct
      }
    } else if(this.userService.isAddressChanged && this.userService.newshippingAddress && this.userService.newshippingAddress.PostalCode){
      if (this.utilityService.getAutoshipEditFlag() && !this.userService.isEditAutoshipAddressChanged) {
        if (this.persistentService.retailData.AutoOrderShippingAddress && !this.utilityService.isEmptyObject(this.persistentService.retailData.AutoOrderShippingAddress)) {
          this.updateAddressWithAutoshipAddress();
        } else {
          this.userService.shippingAddress = cloneDeep(this.userService.newshippingAddress);
          this.user.setShippingAddress();
        }
      } else {
        this.userService.shippingAddress = cloneDeep(this.userService.newshippingAddress);
        this.user.setShippingAddress();
      }
    } else {
      if (this.utilityService.getAutoshipEditFlag() && !this.userService.isEditAutoshipAddressChanged) {
        if (this.persistentService.retailData.AutoOrderShippingAddress && !this.utilityService.isEmptyObject(this.persistentService.retailData.AutoOrderShippingAddress)) {
          if (this.userService.customerData.DefaultShippingAddress && !this.utilityService.isEmptyObject(this.userService.customerData.DefaultShippingAddress)) {
            this.user.setShippingAddress();
          }
          this.updateAddressWithAutoshipAddress();
        } else {
          this.userService.shippingAddress = cloneDeep(this.userService.customerData.DefaultShippingAddress || {});
          this.user.setShippingAddress();
        }
      } else {
        // For one-time orders: Only reset to default if address hasn't been changed
        // This preserves any address updates made on the shipping page
        if (!this.userService.isAddressChanged || !this.userService.shippingAddress || !this.userService.shippingAddress.Street1) {
          this.userService.shippingAddress = cloneDeep(this.userService.customerData.DefaultShippingAddress || {});
          this.user.setShippingAddress();
        }
      }
    }

    if (this.userService.shippingMethods?.length > 0) {
      this.checkItems().then(() => {
      });
    } else {
      if (this.itemsService.selectedOrderItems.length) {
        this.checkItems().then(() => {
          this.orderService.calculateOrder().then(() => {
          });
        });
      }
      if (this.itemsService.selectedAutoOrderItems.length) {
        this.checkItems().then(() => {
          this.orderService.calculateAutoOrder().then(() => {
          });
        });
      }
    }

    if (this.utilityService.getAutoshipEditFlag()) {
      if (this.persistentService.retailData.SelectedAutoshipPayment) {
        const autoshipPayment = this.getPaymentByDisplayText(
          this.persistentService.retailData.SelectedAutoshipPayment.PaymentDisplay,
          this.persistentService.retailData.SelectedAutoshipPayment.PaymentTypeID
        );
        this.userService.paymentMethods = autoshipPayment ? [autoshipPayment] : [];
        if (this.userService.paymentMethods.length > 0) {
          this.userService.paymentMethods[0].CardType = this.userService.paymentMethods[0].Name,
            this.userService.paymentMethods[0].Last4 = this.userService.paymentMethods[0].Ending,
            this.userService.paymentMethods[0].ExpireMonth = this.persistentService.retailData.SelectedAutoshipPayment.ExpireMonth,
            this.userService.paymentMethods[0].ExpireYear = this.persistentService.retailData.SelectedAutoshipPayment.ExpireYear,
            this.userService.paymentMethods[0].Token = this.userService.paymentMethods[0].PaymentMethodID,
            this.userService.paymentMethods[0].BillingAddress = this.persistentService.retailData.SelectedAutoshipPayment.BillingAddress,
            this.userService.paymentMethods[0].BillingAddress2 = this.persistentService.retailData.SelectedAutoshipPayment.BillingAddress2,
            this.userService.paymentMethods[0].BillingCity = this.persistentService.retailData.SelectedAutoshipPayment.BillingCity,
            this.userService.paymentMethods[0].BillingCountry = this.persistentService.retailData.SelectedAutoshipPayment.BillingCountry,
            this.userService.paymentMethods[0].BillingState = this.persistentService.retailData.SelectedAutoshipPayment.BillingState,
            this.userService.paymentMethods[0].BillingZip = this.persistentService.retailData.SelectedAutoshipPayment.BillingZip;
        }
      }
      if (this.userService.paymentMethods.length == 0) {
        this.setDefaultPayment();
      }
      if (this.userService.paymentMethods.length > 0) {
        this.paymentService.selectedPaymentTypeName = this.userService.paymentMethods[0].CardType + ' ' + this.userService.paymentMethods[0].Last4;
      }
      sessionStorage.setItem('userService', JSON.stringify(this.userService));
    } else {
      this.setDefaultPayment();
    }

    if (Object.keys(this.userService.customerData).length && this.itemsService.selectedAutoOrderItems.length > 0) {
      this.getAutoOrders();
    }
    this.userService.isPaymentChanged = false;
    
    this.getfrequencyName();
    // this.getCustomerSavedPaymentMethod();
  }

  public getCurrentAutoshipId(): number | string {
    const fromLocalState = this.autoshipId || this.persistentService?.retailData?.CurrentSelectedAutoOrder;

    if (fromLocalState) { return fromLocalState; }

    const fromCart = this.itemsService?.selectedAutoOrderItems?.[0]?.AutoOrderID;
    if (fromCart) { return fromCart; }

    const fromSelected = this.selectedAutoship || this.AutoOrdersData?.[0]?.AutoShipID;
    if (fromSelected) { return fromSelected; }

    const fromEditSnapshot = this.persistentService?.retailData?.editAutoshipItems?.[0]?.AutoOrderID;
    if (fromEditSnapshot) { return fromEditSnapshot; }

    return 0;
  }
getCustomerRewardPoints(customerId){
  this.apiService.GetCustomerRewardPoints(customerId)
      .subscribe((result: any) => {
        const { Data } = result;
        if(typeof Data == "number") {
          this.userService.customerData['rewardPointBalance'] = Data;

        }
      });
}
  private loadAutoshipShippingAddress(autoOrderId: number) {
    this.apiService.getAutoship(autoOrderId).subscribe((result) => {
      if (result && result.Data && result.Data.ShipAddress) {
        const shipAddress = result.Data.ShipAddress;
        
        let displayName = shipAddress.ShipTo;
        if (!displayName || displayName.trim() === '') {
          const firstName = this.userService.customerData?.FirstName;
          const lastName = this.userService.customerData?.LastName;
          displayName = (firstName && lastName) ? `${firstName} ${lastName}`.trim() : '';
        }
        
        let firstName = '';
        let lastName = '';
        if (shipAddress.ShipTo && shipAddress.ShipTo.trim() !== '') {
          const nameParts = shipAddress.ShipTo.trim().split(' ');
          firstName = nameParts[0] || '';
          lastName = nameParts.slice(1).join(' ') || '';
        } else {
          firstName = this.userService.customerData?.FirstName || '';
          lastName = this.userService.customerData?.LastName || '';
        }
        
        this.persistentService.retailData.AutoOrderShippingAddress = {
          ShipTo: displayName,
          FirstName: firstName,
          LastName: lastName,
          Address: shipAddress.Street1 || '',
          Address2: shipAddress.Street2 || '',
          Address3: shipAddress.Street3 || '',
          City: shipAddress.City || '',
          State: shipAddress.Region || '',
          Country: shipAddress.CountryCode || '',
          ZipCode: shipAddress.PostalCode || ''
        };
        
        this.persistentService.setRetailData();
        
        if (!this.userService.isEditAutoshipAddressChanged) {
          if (this.userService.customerData.DefaultShippingAddress && !this.utilityService.isEmptyObject(this.userService.customerData.DefaultShippingAddress)) {
            this.user.setShippingAddress();
          }
          this.updateAddressWithAutoshipAddress();
        } else {
          if (this.userService.shippingAddress && this.userService.shippingAddress.Street1) {
            this.persistentService.retailData.AutoOrderShippingAddress = {
              ShipTo: this.userService.shippingAddress.FullName?.trim() ||
                ((this.userService.shippingAddress.FirstName && this.userService.shippingAddress.LastName) ? `${this.userService.shippingAddress.FirstName} ${this.userService.shippingAddress.LastName}`.trim() : ''),
              FirstName: this.userService.shippingAddress.FirstName || '',
              LastName: this.userService.shippingAddress.LastName || '',
              Address: this.userService.shippingAddress.Street1 || '',
              Address2: this.userService.shippingAddress.Street2 || '',
              Address3: this.userService.shippingAddress.Street3 || '',
              City: this.userService.shippingAddress.City || '',
              State: this.userService.shippingAddress.Region || '',
              Country: this.userService.shippingAddress.CountryCode || '',
              ZipCode: this.userService.shippingAddress.PostalCode || ''
            };
            this.persistentService.setRetailData();
          }
        }
      }
    }, (error) => {
      console.error('Error loading autoship shipping address:', error);
      if (this.userService.customerData.DefaultShippingAddress && !this.utilityService.isEmptyObject(this.userService.customerData.DefaultShippingAddress)) {
        this.user.setShippingAddress();
      }
    });
  }

  public updateAddressWithAutoshipAddress() {
    if (!this.persistentService.retailData.AutoOrderShippingAddress || 
        this.utilityService.isEmptyObject(this.persistentService.retailData.AutoOrderShippingAddress)) {
      return;
    }
    
    const autoOrderAddress = this.persistentService.retailData.AutoOrderShippingAddress;
    
    if (autoOrderAddress.ShipTo && autoOrderAddress.ShipTo.trim() !== '') {
      this.userService.shippingAddress.FullName = autoOrderAddress.ShipTo.trim();
      const nameParts = autoOrderAddress.ShipTo.trim().split(' ');
      this.userService.shippingAddress.FirstName = nameParts[0] || '';
      this.userService.shippingAddress.LastName = nameParts.slice(1).join(' ') || '';
    } else if (autoOrderAddress.FirstName || autoOrderAddress.LastName) {
      this.userService.shippingAddress.FirstName = autoOrderAddress.FirstName || '';
      this.userService.shippingAddress.LastName = autoOrderAddress.LastName || '';
      this.userService.shippingAddress.FullName = `${autoOrderAddress.FirstName || ''} ${autoOrderAddress.LastName || ''}`.trim();
    } else {
      const firstName = this.userService.customerData?.FirstName || '';
      const lastName = this.userService.customerData?.LastName || '';
      this.userService.shippingAddress.FirstName = firstName;
      this.userService.shippingAddress.LastName = lastName;
      this.userService.shippingAddress.FullName = `${firstName} ${lastName}`.trim();
    }
    
    this.userService.shippingAddress.Street1 = autoOrderAddress.Address || '';
    this.userService.shippingAddress.Street2 = autoOrderAddress.Address2 || '';
    this.userService.shippingAddress.Street3 = autoOrderAddress.Address3 || '';
    this.userService.shippingAddress.City = autoOrderAddress.City || '';
    this.userService.shippingAddress.CountryCode = autoOrderAddress.Country || '';
    this.userService.shippingAddress.Region = autoOrderAddress.State || '';
    this.userService.shippingAddress.PostalCode = autoOrderAddress.ZipCode || '';
    
    sessionStorage.setItem('userService', JSON.stringify(this.userService));
  }

  setDefaultPayment() {
    this.paymentService.getPaymentType().then(() => {
        const saveMethods = this.paymentService.PaymentTypeResponse['SaveMethods'];
        if (saveMethods && saveMethods.length > 0) {
            this.addSavePayment(saveMethods[0]);
            sessionStorage.setItem("userService", JSON.stringify(this.userService));
        }
    }).catch(error => {
        console.error("Error fetching payment types:", error);
    });
}


  getPaymentByDisplayText(text, paymentmethodid) {
    let matchingPayment = null;
    this.paymentService.PaymentTypeResponse['SaveMethods']?.some((method) => {
      try {
        let ending = method.Ending || method.CreditCardNumberDisplay || method.Last4 || method.Name;

        if (ending) {
          ending = ending.replace(/\*/g, '');
        }
        if (paymentmethodid == method.PaymentMethodID) {
          matchingPayment = method;
          return true;
        }
        if (!method.PaymentMethodID && ~text.indexOf(ending)) {
          matchingPayment = method;
          return true;
        }
      } catch (e) {
        console.error('Message', e);
        return true;
      }
    });
    return matchingPayment;
  }

  public getTotal(): Observable<number> {
    return this.cartService1.getTotalAmount();
  }
  getQuantityModel(type, item): any {
    return this.cart1Service[type == 'pack' ? 'packQuantity' : (type == 'autoship' ? 'autoshipQuantity' : ((item && item?.UsePoints) ? 'orderRewardQuantity' : 'orderQuantity'))];
  }
  // Payment Section
  addSavePayment(paymentData) {
    if (
      !this.utilityService.isEmptyObject(
        this.paymentService.SelectedPaymentTypes,
      ) &&
      this.paymentService.SelectedPaymentTypes.MerchantId !==
      paymentData.MerchantId
    ) {
      this.userService.paymentMethods = [];
      this.userService.isPaymentChanged = true;
    }
    this.paymentService.SelectedPaymentTypes = paymentData;
    this.paymentService.selectedPaymentTypeName =
      this.paymentService.SelectedPaymentTypes.DisplayName;
    if (this.paymentService.SelectedPaymentTypes.CanSavePayments) {
      this.paymentService.OldSelectedPaymentType =
        this.paymentService.SelectedPaymentTypes;
      this.paymentService.getPaymentData(paymentData).then(() => {
        this.setDefaultPayment();
      });
    } else {
      this.paymentService.oldSelectedPaymentTypeName =
        this.paymentService.selectedPaymentTypeName;
      this.userService.paymentMethods = [];
      const selectpay = {
        CardType:
          this.paymentService.SelectedPaymentTypes.CardType ||
          this.paymentService.SelectedPaymentTypes.Name,
        Last4: this.paymentService.SelectedPaymentTypes.Ending,
        ExpireMonth: this.paymentService.SelectedPaymentTypes.Expires
          ? parseInt(moment.utc(this.paymentService.SelectedPaymentTypes.Expires).format('M'), 10)
          : 0,
        ExpireYear: this.paymentService.SelectedPaymentTypes.Expires
          ? parseInt(moment.utc(this.paymentService.SelectedPaymentTypes.Expires).format('YYYY'), 10)
          : 0,
        Token: this.paymentService.SelectedPaymentTypes.PaymentMethodId
          ? this.paymentService.SelectedPaymentTypes.PaymentMethodId
          : "",
        MerchantId: this.paymentService.SelectedPaymentTypes.MerchantId,
      };
      this.userService.paymentMethods.push(selectpay);
    }
    sessionStorage.setItem("userService", JSON.stringify(this.userService));
    if(paymentData.CanGetBalance){
      this.isShowEwalletBalance = true;
      this.fetchCustomerBalance(paymentData.MerchantId, this.userService.customerData.CustomerId);
    }else{
      this.isShowEwalletBalance = false;
    }
  }

  getPaymentDescription(payment) {
    if (!payment) {
      return '';
    }
    if (payment.CreditCardTypeDescription === 'Unknown') {
      return payment.CreditCardTypeDescription;
    }
    const type = payment.CreditCardTypeDescription || payment.Name || payment.CardType;
    const numb = payment.CreditCardNumberDisplay || new AddSymbolWithNumberPipe().transform(payment.Ending, '*', 4, 11) ||
      new AddSymbolWithNumberPipe().transform(payment.Last4, '*', 4, 11);
    return type + ' ' + numb;
  }

  removeCardDetail(payment) {
    const messageText = this.translate.instant('confirm_delete_payment_info') + ' ' + this.getPaymentDescription(payment) + '?';
    const dialogRef1 = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '400px',
      data: {
        title: '',
        message: messageText,
        takeaction: this.translate.instant('Delete'),
        noaction: this.translate.instant('cancel'),
      },
      panelClass: '',
      disableClose: true

    });
    dialogRef1.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.deleteCreditCard(payment);
      }
    });
  }

  deleteCreditCard(payment) {
    const DeleteCreditCardRequest = {
      customerId: this.userService.customerData.CustomerId,
      merchantid: payment.MerchantId,
      paymentmethodid: payment.PaymentMethodId
    };
    this.apiService
      .deletePaymentMethod(DeleteCreditCardRequest).subscribe((result) => {
        try {
          if (parseInt(result.Status, 10) === 0) {
            if (this.paymentService.selectedPaymentTypeName == (payment.Name + ' ' + payment.Ending)) {
              this.paymentService.SelectedPaymentTypes = {};
              this.userService.paymentMethods = [];
              this.paymentService.selectedPaymentTypeName = '';
              this.paymentService.selectedPaymentTypeName = this.translate.instant('Add_Payment_Method');
            }
            this.notificationService.success('Success', this.translate.instant('successfully_deleted'));
            this.setDefaultPayment();
          } else {
            this.notificationService.error('Error', (result.Message ? result.Message : this.translate.instant('not_remove')));
          }
        } catch (ex) {
          console.error('ex', ex);
        }
      }, (error) => {
        this.notificationService.error('Error', this.translate.instant('not_remove'));
      },
        () => {
        });
  }

  getCvv(result) {
    if (result) {
      this.autoshipId ? this.placeAutoOrder() : this.placeOrder(result);
    } else {
      this.isDisabledCreateOrder = false;

    }
  }

  checkPlaceOrder() {
    if (this.user.checkIfUserAuthenticatedOrNot()) {
      const showCvv = '99'.split(',').filter((item) => {
        return item && item == this.paymentService.SelectedPaymentTypes.MerchantId;
      }).length;
      if (this.paymentService.SelectedPaymentTypes && Object.keys(this.paymentService.SelectedPaymentTypes).length &&
        this.userService.paymentMethods.length && (!this.isStateRestrict && (Object.keys(this.userService.shippingAddress).length > 0)) && (showCvv)) {
        // SHow Allow CVV Model Popup
        const dialogData = this.dialog.open(AllowCvvComponent, {
          disableClose: true,
          panelClass: 'allowCvvModel-dialog'
        });
        dialogData.afterClosed().subscribe((dialogResult) => {
          if (dialogResult) {
            this.getCvv(dialogResult);
          }
        });
      } else {
        this.autoshipId ? this.placeAutoOrder() : this.placeOrder();
      }
    }
    else {
      // Logout and go to home
      this.accountService.logout();
      this.router.navigate(['/home']);
    }
  }


  placeOrder(dataCvvCode?: any) {
    const userData = JSON.parse(sessionStorage.getItem("user"));
    const placeOrderPromise = new Promise((resolve, reject) => {
      // if (this.itemsService.selectedAutoOrderItems.length > 0 && false) {
      //   this.notificationService.error('error_', 'choose_frequency_sidecart');
      //   this.isDisabledCreateOrder = false;
      //   return;
      // }

      // if (this.userService.newUser && this.itemsService.selectedAutoOrderItems.length == 0) {
      //   this.notificationService.error('error_', 'autoship_required_msg');
      //   this.isDisabledCreateOrder = false;
      //   return;
      // }
      if (this.userService.paymentMethods.length > 0) {
        if (this.userService.paymentMethods[0].Last4 || this.userService.paymentMethods[0].Last4 === undefined) {
        } else {
          this.notificationService.error('error_', 'shop_please_add_payment');
          this.isDisabledCreateOrder = false;
          return;
        }
      } else {
        this.notificationService.error('error_', 'shop_please_add_payment');
        this.isDisabledCreateOrder = false;
        return;
      }

      // if (this.isStateRestrict || (!Object.keys(this.userService.shippingAddress).length) || (!this.userService.shippingAddress.FirstName || !this.userService.shippingAddress.LastName || !this.userService.shippingAddress.Street1 || !this.userService.shippingAddress.PostalCode)) {
      //   this.notificationService.error('error_', 'please_add_address');
      //   this.isDisabledCreateOrder = false;
      //   return;
      // }
      
      // if(this.itemsService.selectedOrderItems.length == 0) {
      //    this.notificationService.error('error_','your_order_cart_empty_select_atleast_one_item');
      //    setTimeout(() => {
      //      this.router.navigate(['/shop']);
      //    }, 1000);
      //    return;
      // }
      let orderSubtotal = 0;
      const productdetails: Array<Item> = [];
      _.each(this.itemsService.selectedOrderItems, (item) => {
        const itemTotal = (item.AutoshipPrice || 0) * (item.Quantity || 1); 
        orderSubtotal += itemTotal;
        productdetails.push({
          ItemId: item.ItemID,
          IsReward: false,
          Quantity: !item.UsePoints ? item.Quantity : item.rewardQuantity
        });
      });

      const autoshipproductdetails: Array<Item> = [];
      _.each(this.itemsService.selectedAutoOrderItems, (item) => {
        if (parseInt(item.Quantity, 10) > 0) {
          autoshipproductdetails.push({
            ItemId: item.ItemID,
            IsReward: false,
            Quantity: item.Quantity
          });
        }
      });
      // Use the rewardBalance value instead of calculating from individual items
      const totalRewardPointsUsed: number = this.rewardBalance || 0;
      // Use user's selected shipping method first, then fall back to calculated method
      // Pass isFirstOrder flag for first order free shipping eligibility (US only)
      const calculatedShipMethodId = this.shippingMethodService.getShippingMethodId(orderSubtotal, this.userService?.customerTypeID, this.orderService.isAutoshipAvail(), totalRewardPointsUsed, this.isFirstOrder);
      const shipMethodId = this.userService?.selectedShippingMethod || calculatedShipMethodId || "11";
      
      // Ensure country code is in uppercase format
      const countryCode = (this.userService.shippingAddress.CountryCode || DefaultCountry).toUpperCase();
      
      this.createOrderRequest = {
        customerId: userData?.CustomerId || this.userService?.customerData?.CustomerId,
        createOrder: {
          customerType: this.itemsService?.selectedAutoOrderItems?.length > 0 ? 3 : "",
          ShippingAddress: {
            ShipTo: this.userService.shippingAddress?.FullName?.trim() ||
              ((this.userService.shippingAddress?.FirstName && this.userService.shippingAddress?.LastName) ? `${this.userService.shippingAddress.FirstName} ${this.userService.shippingAddress.LastName}`.trim() : ''),
            Line1: this.userService.shippingAddress.Street1 || "",
            Line2: this.userService.shippingAddress.Street2 || "",
            State: this.userService.shippingAddress.Region || "",
            City: this.userService.shippingAddress.City || "",
            Zip: this.userService.shippingAddress.PostalCode || "",
            CountryCode: countryCode,
          } as OrderShippingAddress,
          CountryCode: countryCode,
          // Attention: "No Attention Needed",
          CouponCodes: [],
          CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
          // FirstName: this.userService.shippingAddress.FirstName,
          Items: productdetails,
          // LastName: this.userService.shippingAddress.LastName,
          // OrderType: 1,
          // PartyId: 0,
          Payments: [
            {
              CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
              MerchantId: this.userService.paymentMethods[0].MerchantId,
              OnFileCard: "",
              OrderCreditCard: {
                CardToken: this.userService.paymentMethods[0].Token,
                NameOnCard: (this.userService.paymentMethods[0].billingInfo &&
                  this.userService.paymentMethods[0].billingInfo.fullName) ||
                  "",
                Last4: this.userService.paymentMethods[0].Last4,
                CardType: this.userService.paymentMethods[0].CardType,
                ExpirationMonth: this.userService.paymentMethods[0].ExpireMonth || 1,
                ExpirationYear: this.userService.paymentMethods[0].ExpireYear,
              } as OrderCreditCard,
              SavePayment: true,
              SavePaymentMethodId: this.userService.paymentMethods[0].Token,
              Amount: totalRewardPointsUsed > 0 ? Math.max(0, this.orderService.calculateOrderResponse.Total - totalRewardPointsUsed) : this.orderService.calculateOrderResponse.Total,
            },
          ] as Array<Payment>,
          // Phone: this.userService.shippingAddress.Phone,
          PriceGroup: userData?.CustomerType || this.userService?.customerData?.CustomerType,
          ShipMethodId: shipMethodId || this.userService.selectedShippingMethod || "11",
          // SpecialInstructions: "No Instruction",
          StoreId: (this.user?.userServiceModal?.customerData?.IsCorporate == true ?  CORPORATESTOREID : this.orderService.retailStoreId) || '3' //this.shoppingCartService.getShoppingCart(1)[0]?.StoreID,
          // Custom: null,
        } as unknown as CreateOrder,
      } as CreateOrderAndAutoShip;
      // if(totalRewardPointsUsed > 0) {
      //   this.createOrderRequest.createOrder.Payments.push(
      //     {
      //       "Amount": totalRewardPointsUsed,
      //       "CurrencyCode": "RWD",
      //       "MerchantId": 11,
      //       "OnFileCard": "",
      //       "SavePayment": false
      //     }
      //   );
      // }
      if (autoshipproductdetails.length > 0) {
        this.createOrderRequest.createAutoOrder = {
          ShipMethodId: shipMethodId || this.userService.selectedShippingMethod || "11",
          Frequency: this.persistentService.retailData.Autoship.FrequencyTypeDescription || 'Monthly',
          Items: autoshipproductdetails,
          MerchantId: this.userService.paymentMethods[0].MerchantId,
          // PaymentMerchantId: this.userService.paymentMethods[0].MerchantId,
          PaymentMethodId: this.userService.paymentMethods[0].token || this.userService.paymentMethods[0].Token,
          CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
          ShipAddress: {
            ShipTo: this.userService.shippingAddress?.FullName?.trim() ||
              ((this.userService.shippingAddress?.FirstName && this.userService.shippingAddress?.LastName) ? `${this.userService.shippingAddress.FirstName} ${this.userService.shippingAddress.LastName}`.trim() : ''),
            AddressId: 0,
            Street1: this.userService.shippingAddress.Street1 || '',
            Street2: this.userService.shippingAddress.Street2 || '',
            Street3: this.userService.shippingAddress.Street3 || '',
            Region: this.userService.shippingAddress.Region || '',
            City: this.userService.shippingAddress.City || '',
            PostalCode: this.userService.shippingAddress.PostalCode || '',
            CountryCode: countryCode
          } as ShipAddress,
          ShippingAddress: {
            ShipTo: this.userService.shippingAddress?.FullName?.trim() ||
              ((this.userService.shippingAddress?.FirstName && this.userService.shippingAddress?.LastName) ? `${this.userService.shippingAddress.FirstName} ${this.userService.shippingAddress.LastName}`.trim() : ''),
            AddressId: 0,
            Street1: this.userService.shippingAddress.Street1 || '',
            Street2: this.userService.shippingAddress.Street2 || '',
            Street3: this.userService.shippingAddress.Street3 || '',
            Region: this.userService.shippingAddress.Region || '',
            City: this.userService.shippingAddress.City || '',
            PostalCode: this.userService.shippingAddress.PostalCode || '',
            CountryCode: countryCode
          } as ShipAddress,
          StartDate: this.autoshipConfigurationService.autoshipDate,
          Custom:{
            AutoShipId:0
          }  as Custom,
        } as CreateAutoOrder;
 
        if (!this.persistentService.retailData.isNewAutoship) {
          this.createOrderRequest.createAutoOrder.Custom = {
            AutoShipId: this.selectedAutoship || 0
          } as Custom;
        }
      }
      this.UseWalletToPayRemainder && (this.createOrderRequest["UseWalletToPayRemainder"] = true);
       if(this.rewardBalance > 0){
         this.createOrderRequest.createOrder["UseMyWalletAccount"] = true;
         this.createOrderRequest.createOrder["WalletUsedPoints"] = this.rewardBalance;
       }
      this.createOrderRequest.createOrder.PartyId = this.utilityService.getQueryParam('partyid') || sessionStorage.getItem('partyId') || 0;
      this.apiService.createCustomerOrderAndAutoship(this.createOrderRequest).subscribe((result) => {
        this.isDisabledCreateOrder = false;
        if (result.ErrorMessage === 'CreateOrder_Failed') {
          const whichCard = result.Index === '0' ? 'First' : 'Second';
          const message = whichCard + ' Card failed with Amount: ' + result.Amount;
          this.notificationService.error('error_', this.translate.instant(message));
          reject(this.translate.instant(message));
          return;
        }

        if (result.ErrorMessage === 'invalid_credit_card') {
          this.notificationService.error('error_', this.translate.instant(result.ErrorMessage));
          reject(this.translate.instant(result.ErrorMessage));
          return;
        }

        if (!result.Order?.OrderId && !result?.AutoOrder?.AutoorderId) {
          this.notificationService.error('error_', this.translate.instant(result.ErrorMessage));
          reject(this.translate.instant(result.ErrorMessage));
          return;
        }

        result.OrderID = (result?.Order?.OrderID || result?.Order?.OrderId);
        result.AutoOrderId = (result?.AutoOrder?.AutoOrderID || result?.AutoOrder?.AutoorderId);
        if (result.OrderID || (result.AutoOrderId || result.AutoOrderId > 0)) {
          this.userService.newUser = false;
          var autoshipItems: any = [];
          var standardItems: any = [];
          try {
            autoshipItems = JSON.parse(sessionStorage.getItem('cart.autoship')) || [];
            standardItems = JSON.parse(sessionStorage.getItem('cart.order')) || [];
          } catch (error) {

          }
          if (result.OrderID) {
            try {
              var items: any = [];
              this.createOrderRequest.createOrder?.Items.forEach(ele => {
                this.itemsService.getProduct(ele.ItemId).subscribe(product => {
                  items.push({
                    "itemId": product.ItemID,
                    "productName": product.ProductName,
                    "sku": product.SKU,
                    "quantity": ele.Quantity,
                    "qv": product.QV,
                    "cv": product.CV,
                    "bonus": product.Bonus,
                    "price": product.Price,
                    "languageCode": product.LanguageCode,
                    "currencyCode": product.CurrencyCode,
                  })
                });
              })
              var data = [{
                "orderId": result.OrderID,
                "customerId": this.user.userServiceModal.customerData.CustomerId,
                "sponsorId": this.user.userServiceModal.customerData.SponsorId,
                "orderDetail": {
                  "items": items,
                  "subTotal": this.orderService.calculateOrderResponse.SubTotal || 0,
                  "totalAmount": this.orderService.calculateOrderResponse.Total || 0
                }
              }]
              var tempData = JSON.stringify(data);
              window['ZTM'].setStats('commonsense', "PlaceOrder", tempData);
            } catch (error) {

            }
          }
          if (result.AutoOrderId || result.AutoOrderId > 0) {
            try {
              var items: any = [];
              this.createOrderRequest.createAutoOrder?.Items.forEach(ele => {
                autoshipItems.forEach(product => {
                  if (parseInt(product.ItemID) == ele.ItemId) {
                    items.push({
                      "itemId": product.ItemID,
                      "productName": product.ProductName,
                      "sku": product.SKU,
                      "quantity": ele.Quantity,
                      "qv": product.QV,
                      "cv": product.CV,
                      "bonus": product.Bonus,
                      "price": product.Price,
                      "languageCode": product.LanguageCode,
                      "currencyCode": product.CurrencyCode,
                    })
                  }
                });
              })
              var Autodata = [{
                "orderId": result.AutoOrderId,
                "customerId": this.user.userServiceModal.customerData.CustomerId,
                "sponsorId": this.user.userServiceModal.customerData.SponsorId,
                "orderDetail": {
                  "items": items,
                  "subTotal": this.orderService.calculateAutoOrderResponse.SubTotal || 0,
                  "totalAmount": this.orderService.calculateAutoOrderResponse.Total || 0
                }
              }]
              var tempData = JSON.stringify(Autodata);
              window['ZTM'].setStats('commonsense', "PlaceOrder", tempData);
            } catch (error) {
            }
          }
          sessionStorage.setItem('SubmitApplication', JSON.stringify(result));
          if (result?.Order?.OrderId) {
            this.apiService.GetCustomerRewardPoints(this.user.userServiceModal.customerData.CustomerId)
            .subscribe((result: any) => {
              const { Data } = result;
              if(typeof Data == "number") {
                this.userService.customerData['rewardPointBalance'] = Data;

              }
            });
            if (result.Order.Payment?.PaymentUrl) {
              const iframeData = result.Order.Payment?.PaymentUrl
              this.getpaymentMethodIframe(iframeData)
            } else {
              this.router.navigate(["/complete"]);
            }
          } else {
            this.utilityService.setAutoshipEditFlag(false);
            this.persistentService.retailData.isChanged = true;
            this.userService.isAddressChanged = false;
            this.userService.isPaymentChanged = false;
            this.userService.isShipMethodChanged = false;
            this.persistentService.retailData.isNewAutoship = true;
            this.persistentService.retailData.editAutoshipItems = [];
            if (result.Order?.Redirect && result.Order.RedirectUrl && result.Order.RedirectUrl.length > 0) {
              window.location = result.Order.RedirectUrl;
            }
            if (result.AutoOrder?.Redirect && result.AutoOrder.RedirectUrl && result.AutoOrder.RedirectUrl.length > 0) {
              window.location = result.AutoOrder.RedirectUrl;
            }
            this.router.navigate(['/complete']);
          }
        }
        resolve(result);
      }, (error) => {
        reject(this.translate.instant('some_error_occur_try_again'));
        this.isDisabledCreateOrder = false;
        this.notificationService.error('error_', this.translate.instant('some_error_occur_try_again'));
      }, () => { });
    });
    return placeOrderPromise;
  }

  showBirthWarnings() {
    const orderItem = this.itemsService.selectedOrderItems.some((item) => {
      return item.FlagCancer || item.FlagBirthDefects;
    });
    const autoshipItem = this.itemsService.selectedAutoOrderItems.some((item) => {
      return item.FlagCancer || item.FlagBirthDefects;
    });
    if ((orderItem || autoshipItem) && this.configService.localSettings.Global.ShowBirthWarning) {
      return true;
    } else {
      return false;
    }
  }
  showCancerWarnings() {
    const orderItem = this.itemsService.selectedOrderItems.some((item) => {
      return item.FlagCancer || item.FlagBirthDefects;
    });
    const autoshipItem = this.itemsService.selectedAutoOrderItems.some((item) => {
      return item.FlagCancer || item.FlagBirthDefects;
    });
    if ((orderItem || autoshipItem) && this.configService.localSettings.Global.ShowCancerWarning) {
      return true;
    } else {
      return false;
    }

  }

  checkQuantity(type, item) {
    const quantity = this.getQuantityModel(type, item)[item.ItemID];
    if (!Number(quantity)) {
      this.cart1Service.removeFromCart(item, type == 'autoship', type == 'pack', true);
    } else {
      if (!item.UsePoints) {
        item.Quantity = quantity;
      }
      else if (item.UsePoints) {
        item.rewardQuantity = quantity;
      }
      
      // Update packQuantity object to keep it synchronized
      if (type == 'pack') {
        this.cart1Service.packQuantity[item.ItemID] = quantity;
      }
      if (type == 'autoship') {
        sessionStorage.setItem('cart.autoship', JSON.stringify(this.itemsService.selectedAutoOrderItems));
        this.orderService.calculateAutoOrder();
      } else {
        sessionStorage.setItem((type == 'pack' ? 'cart.packs' : 'cart.order'), JSON.stringify(type == 'pack' ? this.itemsService.selectedPacks : this.itemsService.selectedOrderItems));

        this.orderService.calculateOrder();
      }
    }
  }
  getAutoOrders() {
    this.apiService.getCustomerAutoships(this.userService.customerData.CustomerId).subscribe((result: any) => {
      try {
        if (Number(result.Status) === 0) {
          if (result.Data && result.Data.length > 0) {
            var data = result.Data.filter(item => { return parseInt(item.AutoShipType) != 2 });
            this.AutoOrdersData = this.orderPipe.transform(data, 'AutoShipID', true);
            // Show selected Autoship in dropdown
            this.selectedAutoship = this.persistentService.retailData.CurrentSelectedAutoOrder || this.AutoOrdersData[0].AutoShipID;
          }
        }
      } catch (ex) {
        console.error('ex', ex);
      }
    }, (error) => {
      this.AutoOrdersData = [];
    }, () => { });
  }

  changeSelectedAutosipId(id: any) {
    this.selectedAutoship = id;
  }

  backStep() {
    if (this.isAutoshipMode()) {
      if (this.autoshipId) {
        this.router.navigate(['/autoship'], { queryParams: { autoshipId: this.autoshipId }});
      } else {
        this.router.navigate(['/autoship']);
      }
    } else {
      this.router.navigate(['/products/all']);
    }
  }

  isAutoshipChanged() {
    if (!moment(this.autoshipConfigurationService.autoshipDate).isSame(this.autoshipConfigurationService.autoshipDate, 'day')) {
      return true;
    }
    if (this.persistentService.retailData.Autoship && this.commonData.FrequencyTypes[0].ID != this.persistentService.retailData.Autoship.FrequencyTypeID) {
      return true;
    }
    if (this.userService.isAddressChanged || this.userService.isPaymentChanged || this.userService.isShipMethodChanged) {
      return true;
    }

    if (this.utilityService.getAutoshipEditFlag()) {
      if (this.persistentService.retailData.isChanged) {
        if (_.isEqual(this.persistentService.retailData.editAutoshipItems, this.itemsService.selectedAutoOrderItems) && this.itemsService.selectedOrderItems.length == 0) {
          return false;
        }
        return true;
      }
      return false;
    }
    return true;
  }

  validatePromoCode() {
    if (this.userService.couponInfo.promoCode) {
      if (this.userService.couponInfo.availableRewards.length > 0) {
        _.each(this.userService.couponInfo.availableRewards, (avlreward) => {
          if (avlreward.Code.toLowerCase() == this.userService.couponInfo.promoCode.toLowerCase()) {
            this.userService.couponInfo.RewardsForUse.push(avlreward);
          }
        });
      }
    }
    this.userService.couponInfo.IsAppliedcode = true;
    this.orderService.calculateOrder(false, this.rewardBalance).then((result: any) => {
      if (result && this.userService.couponInfo.promoCode) {
        _.each(this.orderService.calculateOrderResponse.CouponResults, (item) => {
          const isInCart = this.userService.couponInfo.Allcoupons.some((code) => {
            if (code.toLowerCase() == item.Code.toLowerCase()) {
              return true;
            }
            return false;
          });

          if (item.IsValid) {
            if (!isInCart) {
              this.userService.couponInfo.Allcoupons.push(item.Code);
            }
            if (this.userService.couponInfo.promoCode == item.Code) {
              this.notificationService.success('success', 'coupon_added_success');
            }
            this.userService.couponInfo.promoCodeValid = true;
            this.userService.couponInfo.promoCode = '';
          } else {
            this.userService.couponInfo.promoCodeValid = false;
            this.userService.couponInfo.IsAppliedcode = false;
            this.userService.couponInfo.promoCode = '';
            if (isInCart && this.itemsService.selectedOrderItems.length) {
              this.userService.couponInfo.Allcoupons = this.userService.couponInfo.Allcoupons.filter((code) => {
                return code.toLowerCase() != item.Code.toLowerCase();
              });
              this.userService.couponInfo.RewardsForUse = this.userService.couponInfo.RewardsForUse.filter((e) => {
                return e.Code.toLowerCase() != item.Code.toLowerCase();
              });
            }
          }
        });
      }
    });
  }

  promoShowHide() {
    let isExitCoupon = [];
    if (this.orderService.calculateOrderResponse.CouponResults != null) {
      isExitCoupon = this.orderService.calculateOrderResponse.CouponResults.filter((Coupon: any) => {
        if (Coupon.Code === 'NewCustomerPromo_' + this.userService.customerData.BackOfficeId) {
          return Coupon.Code;
        } else if (Coupon.IsValid && (Coupon.Code === this.userService.DynamicCouponCode.promoCode)) {
          return Coupon.Code;
        }
      });
    }
    if (isExitCoupon.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  removePromo(code) {
    this.userService.couponInfo.RewardsForUse = _.reject(this.userService.couponInfo.RewardsForUse, (e) => {
      return e.Code.toLowerCase() == code.toLowerCase();
    });
    this.userService.couponInfo.promoCode = '';
    this.userService.couponInfo.promoCodeValid = true;
    this.userService.couponInfo.IsAppliedcode = false;
    this.userService.couponInfo.Allcoupons = _.without(this.userService.couponInfo.Allcoupons, code);
    this.orderService.calculateOrder(false, this.rewardBalance);
  }

  isCouponCode(Coupon) {
    const NewCustomerPromo = 'NewCustomerPromo_' + this.userService.customerData.BackOfficeId;
    if (Coupon.Code === NewCustomerPromo) {
      return false;
    } else if (Coupon.Code === this.userService.DynamicCouponCode.promoCode) {
      return false;
    } else {
      return true;
    }
  }

  updateShipmethod(shipmethodID) {
    this.userService.selectedShippingMethod = String(shipmethodID);
    if (this.itemsService.selectedOrderItems.length > 0) {
      this.orderService.calculateOrder(false, this.rewardBalance);
    }
    if (this.itemsService.selectedAutoOrderItems.length) {
      this.orderService.calculateAutoOrder();
    }
  }

  checkItems() {
    const promise = new Promise((resolve, reject) => {
      if (this.userService.checkItems) {
        this.itemsListService.checkRestrictedState('', '', true, true, 0, false, '', true, false).then(() => {
          if (this.userService.shippingAddress.Region) {
            _.each(this.userService.restrictedStates, (state) => {
              if ((state).toLowerCase() === (this.userService.shippingAddress.Region).toLowerCase()) {
                this.isStateRestrict = true;
              }
            });
          }
          resolve(true);
        });
      } else {
        if (this.userService.shippingAddress.Region) {
          _.each(this.userService.restrictedStates, (state) => {
            if ((state).toLowerCase() === (this.userService.shippingAddress.Region).toLowerCase()) {
              this.isStateRestrict = true;
            }
          });
        }
        if (this.itemsService.selectedOrderItems.length) {
          this.orderService.calculateOrder();
        }
        if (this.itemsService.selectedAutoOrderItems.length) {
          this.orderService.calculateAutoOrder();
        }
      }
    });
    return promise;
  }

  getfrequencyName() {
    const selected = this.commonData.FrequencyTypes.find(
      ft => ft.ID === this.persistentService.retailData?.Autoship?.FrequencyTypeID
    );
    return { frequency: selected?.Description || '' };
    
  }

  getpaymentMethodIframe(data: any) {
    const dialogRef = this.dialog.open(HostedpaymentDialogComponent, {
      panelClass: "hosted_payment-Dialog",
      data: {
        Width: data.Width,
        Height: data.Height,
        IFrameUrl: data,
        isCheckout: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.setDefaultPayment();
        this.router.navigate(["/complete"]);
      }
    });
  }
  preventNegativeInput(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'Minus') {
      event.preventDefault();
    }
  }
  async validateRewardAmount() {
    this.loader.isLoading.next(true);
    const availableBalance = this.userService.customerData['rewardPointBalance'] || 1;
    if (this.rewardBalance > availableBalance && this.rewardBalance > this.orderService.calculateOrderResponse.SubTotal) {
      this.rewardError = "Reward amount cannot be greater than available balance and cannot exceed order subtotal.";
      this.rewardBalance = 0;
      this.loader.isLoading.next(false);
    } 
    else if (this.rewardBalance > availableBalance) {
      this.rewardError = "Reward amount cannot be greater than available balance.";
      this.rewardBalance = 0;
      this.loader.isLoading.next(false);
    }
    else if (this.rewardBalance > this.orderService.calculateOrderResponse.SubTotal) {
      this.rewardError = "Reward amount cannot exceed order subtotal.";
      this.rewardBalance = 0;
      this.loader.isLoading.next(false);
    } 
    else {
      this.rewardError = '';
      // Recalculate order to update discount total with reward points
      await this.orderService.calculateOrder(false, this.rewardBalance);
      this.loader.isLoading.next(false);
      if (this.rewardBalance && this.rewardBalance > 0) {
        this.notificationService.success('success', this.translate.instant('Reward point added successfully'));
      }
    }
  }

  placeAutoOrder(dataCvvCode?: any) {
    const placeOrderPromise = new Promise((resolve, reject) => {
      if (this.itemsService.selectedAutoOrderItems.length > 0 && this.persistentService.retailData.Autoship.FrequencyTypeID == undefined) {
        this.notificationService.error('error_', 'choose_frequency_sidecart');
        return;
      }

      if (this.itemsService.selectedAutoOrderItems.length == 0) {
        this.notificationService.error('error_', 'autoship_required_msg');
        return;
      }
      if (this.userService.paymentMethods.length > 0) {
        if (this.userService.paymentMethods[0].Last4 || this.userService.paymentMethods[0].Last4 === undefined) {
          this.paymentService.IsFrameReload = false;
        } else {
          this.notificationService.error('error_', 'shop_please_add_payment');
          this.isDisabledCreateOrder = false;
          return;
        }
      } else {
        this.notificationService.error('error_', 'shop_please_add_payment');
        this.isDisabledCreateOrder = false;
        return;
      }

      if (this.isStateRestrict || (!Object.keys(this.userService.shippingAddress).length && !this.userService.shippingAddress.Street1)) {
        this.notificationService.error('error_', 'please_add_address');
        this.isDisabledCreateOrder = false;
        return;
      }

      const autoshipproductdetails: Array<Item> = [];
      _.each(this.itemsService.selectedAutoOrderItems, (item) => {
        if (parseInt(item.Quantity, 10) > 0) {
          autoshipproductdetails.push({
            ItemId: item.ItemID,
            IsReward: false,
            Quantity: item.Quantity
          });
        }
      });

      // Ensure country code is in uppercase format for autoship update
      const autoshipCountryCode = (this.userService.shippingAddress.CountryCode || DefaultCountry).toUpperCase();

      const updateAutoOrderRequest = {
        ShipMethodId: this.userService.selectedShippingMethod || "",
        Frequency: this.persistentService.retailData.Autoship.FrequencyTypeID.toString() || this.persistentService.retailData.Autoship.FrequencyTypeDescription || 'Monthly',
        Items: autoshipproductdetails,
        MerchantId: this.userService.paymentMethods[0].MerchantId || '',
        PaymentMethodId: this.userService.paymentMethods[0].Token || this.paymentService.SelectedPaymentTypes.PaymentMethodId || '',
        ShippingAddress: {
          ShipTo: (this.userService.shippingAddress.FirstName && this.userService.shippingAddress.LastName)
            ? `${this.userService.shippingAddress.FirstName} ${this.userService.shippingAddress.LastName}`.trim()
            : '',
          Street1: this.userService.shippingAddress.Street1 || '',
          Street2: this.userService.shippingAddress.Street2 || '',
          Street3: this.userService.shippingAddress.Street3 || '',
          Region: this.userService.shippingAddress.Region || '',
          City: this.userService.shippingAddress.City || '',
          PostalCode: this.userService.shippingAddress.PostalCode || '',
          CountryCode: autoshipCountryCode
        } as ShipAddress,
        StartDate: this.autoshipConfigurationService.autoshipDate,
      } as CreateAutoOrder;

      this.apiService.updateAutoship(this.autoshipId, updateAutoOrderRequest).subscribe((result) => {
        this.isDisabledCreateOrder = false;
        if (result.Status === 0) {
          this.userService.newUser = false;
          try {

          }
          catch (ex) {
            console.warn('ex', ex);
          }
          result.AutoOrderId = this.autoshipId;
          sessionStorage.setItem('SubmitApplication', JSON.stringify(result));
          this.utilityService.setAutoshipEditFlag(false);
          this.persistentService.retailData.AddMoreItemInAutoshipFlag = false;
          this.persistentService.retailData.AddMoreItemInAutoshipData = {};
          this.persistentService.retailData.isChanged = false;
          this.userService.isAddressChanged = false;
          this.userService.isPaymentChanged = false;
          this.userService.isShipMethodChanged = false;
          this.persistentService.retailData.isNewAutoship = false;
          this.persistentService.retailData.editAutoshipItems = [];
          this.persistentService.retailData.AddMoreItemInAutoshipData = {};
          this.persistentService.retailData.CurrentSelectedAutoOrder = 0;
          this.userService.isAddressChanged = false;
          if (result.RedirectUrl && result.RedirectUrl.length > 0) {
            window.location = result.RedirectUrl;
          } else {
            this.notificationService.success('Success', "Autoship updated successfully");
            this.router.navigate(['/account/autoship']);
          }
          //this.router.navigate(['/complete']);
        }
        else {
          this.notificationService.error('error_', this.translate.instant(result.Message));
        }
        resolve(result);
      }, (error) => {
        reject(this.translate.instant('some_error_occur_try_again'));
        this.isDisabledCreateOrder = false;
        this.notificationService.error('error_', this.translate.instant('some_error_occur_try_again'));
      }, () => { });
    });
    return placeOrderPromise;
  }

  // This need to be fixed as we are not getting the saved payment methods on checkout page so I added it but it's response is different from the we need one
  // getCustomerSavedPaymentMethod(){
  //   const request = {
  //     customerId: this.userService.customerData.CustomerId || 0,
  //     // storeId: 4,
  //   };
  //   this.apiService.getCustomerSavedPaymentMethods(request).subscribe(
  //     (result) => {
  //       try {
  //         if (result.Message === "Success") {
  //           if (result.Data.length == 0) {
  //             this.setDefaultPayment();
  //           }
  //           if (result.Data.length > 0) {
  //             result.Data.forEach((item, i) => {
  //               this.userService.paymentMethods[i].CardType = item.CardType,
  //               this.userService.paymentMethods[i].Last4 = item.Ending,
  //               this.userService.paymentMethods[i].ExpireMonth = this.persistentService.retailData.SelectedAutoshipPayment.ExpireMonth,
  //               this.userService.paymentMethods[i].ExpireYear = this.persistentService.retailData.SelectedAutoshipPayment.ExpireYear,
  //               this.userService.paymentMethods[i].Token = item.PaymentMethodID,
  //               this.userService.paymentMethods[i].BillingAddress = this.persistentService.retailData.SelectedAutoshipPayment.BillingAddress,
  //               this.userService.paymentMethods[i].BillingAddress2 = this.persistentService.retailData.SelectedAutoshipPayment.BillingAddress2,
  //               this.userService.paymentMethods[i].BillingCity = this.persistentService.retailData.SelectedAutoshipPayment.BillingCity,
  //               this.userService.paymentMethods[i].BillingCountry = this.persistentService.retailData.SelectedAutoshipPayment.BillingCountry,
  //               this.userService.paymentMethods[i].BillingState = this.persistentService.retailData.SelectedAutoshipPayment.BillingState,
  //               this.userService.paymentMethods[i].BillingZip = this.persistentService.retailData.SelectedAutoshipPayment.BillingZip;
  //             });
  //             // this.userService.paymentMethods = result.Data;            
  //             this.paymentService.selectedPaymentTypeName = this.userService.paymentMethods[0].CardType + ' ' + this.userService.paymentMethods[0].Last4;
  //           }
  //           sessionStorage.setItem('userService', JSON.stringify(this.userService));
  //         } else {
  //           this.notificationService.error("error_", result.Message);
  //         }
  //       } catch (ex) {
  //         this.notificationService.error(
  //           "error_",
  //           "error_occured_try_again",
  //         );
  //       }
  //     },
  //     (error) => {
  //     },
  //     () => {},
  //   );
  // }

  fetchCustomerBalance(merchantId:number,customerId:string){
    this.apiService.fetchCustomerBalance(merchantId, customerId).subscribe((result) => {
      if (Number(result.Status === 0)) {
        this.ewalletBalance = result.Data;
      }else{
      this.notificationService.error("Error", result.Message);
      }
      
    },error => {
      this.notificationService.error("Error", this.translate.instant('some_error_occur_try_again'));
    })
  }

  // Helper method to check if we're in autoship mode
  private isAutoshipMode(): boolean {
    const inAutoshipMode = this.autoshipId &&
                          this.utilityService.getAutoshipEditFlag() &&
                          this.itemsService.selectedAutoOrderItems.length > 0;

    // If we have autoship items but the flag isn't set, update it
    if (inAutoshipMode && this.itemsService.selectedAutoOrderItems.length > 0 && !this.utilityService.getAutoshipEditFlag()) {
      this.utilityService.setAutoshipEditFlag(true);
    }

    return inAutoshipMode;
  }

  /**
   * Checks if autoship qualifies for free shipping display in the projected totals.
   * Free shipping applies when:
   * - Next process date is 1st-5th of the month, OR
   * - Subtotal is $145 or greater
   * AND the country is not excluded (CA, AU, NZ)
   *
   * @returns boolean indicating if free shipping should be displayed
   */
  shouldDisplayFreeShippingForAutoship(): boolean {
    const selectedCountry = this.configService.commonData.selectedCountry || 'US';
    const excludedCountries = ['CA', 'AU', 'NZ'];

    // Don't show free shipping for excluded countries
    if (excludedCountries.includes(selectedCountry?.toUpperCase())) {
      return false;
    }

    // Check if subtotal is $145 or greater
    const subtotal = this.orderService.calculateAutoOrderResponse?.SubTotal || 0;
    if (subtotal >= 145) {
      return true;
    }

    // Check if autoship date is between 1st-5th of the month
    const autoshipDateStr = this.autoshipConfigurationService.autoshipDate;
    if (autoshipDateStr) {
      const autoshipDate = moment(autoshipDateStr, 'DD MMMM YYYY');
      const dayOfMonth = autoshipDate.date();
      if (dayOfMonth >= 1 && dayOfMonth <= 5) {
        return true;
      }
    }

    return false;
  }

  /**
   * Gets the displayed shipping total for autoship orders.
   * Returns 0 if free shipping conditions are met, otherwise returns actual shipping total.
   */
  getDisplayedAutoshipShippingTotal(): number {
    if (this.shouldDisplayFreeShippingForAutoship()) {
      return 0;
    }
    return this.orderService.calculateAutoOrderResponse?.ShippingTotal || 0;
  }

  /**
   * Fetches fresh customer data and then checks if it's the first order.
   * This ensures OrderCount is available before making the determination.
   */
  private fetchCustomerDataAndCheckFirstOrder(): void {
    // Default to false until we confirm it's a first order
    this.isFirstOrder = false;
    this.orderService.setFirstOrderFlag(false);

    const customerId = this.userService.customerData?.CustomerId;
    if (!customerId) {
      return;
    }

    this.accountService.getCustomerData(customerId).then(() => {
      // Now check if it's the first order with the updated customerData
      this.checkIfFirstOrder();

      // Recalculate order with the correct isFirstOrder flag
      if (this.itemsService.selectedOrderItems.length > 0) {
        this.orderService.resetLastRequests();
        this.orderService.calculateOrder(false, this.rewardBalance);
      }
      if (this.itemsService.selectedAutoOrderItems.length > 0) {
        this.orderService.calculateAutoOrder();
      }
    }).catch(() => {
      // On error, default to not first order for safety
      this.isFirstOrder = false;
      this.orderService.setFirstOrderFlag(false);
    });
  }

  /**
   * Checks if this is the customer's first order for free shipping eligibility
   * First order free shipping applies only to US customers
   *
   * Uses OrderCount from GetCustomer API response (added by BE team)
   */
  private checkIfFirstOrder(): void {
    // Default to false for safety - only set true when we're certain it's a first order
    this.isFirstOrder = false;
    this.orderService.setFirstOrderFlag(false);

    // If editing an existing autoship, it's not a first order
    if (this.utilityService.getAutoshipEditFlag()) {
      this.isFirstOrder = false;
      this.orderService.setFirstOrderFlag(false);
      return;
    }

    const customerData = this.userService?.customerData;

    // If user is logged in (has CustomerId), they are an existing customer
    // Only give free shipping if OrderCount is explicitly 0
    if (customerData?.CustomerId) {
      // Use OrderCount from GetCustomer API response (provided by BE team)
      if (customerData.OrderCount !== undefined && customerData.OrderCount !== null) {
        this.isFirstOrder = customerData.OrderCount === 0;
        this.orderService.setFirstOrderFlag(this.isFirstOrder);
        return;
      }

      // Fallback: check order history via API for logged-in users
      this.apiService.getCustomerOrders(customerData.CustomerId).subscribe(
        (result: any) => {
          if (result && result.Data) {
            // If no previous orders, this is the first order
            this.isFirstOrder = result.Data.length === 0;
            this.orderService.setFirstOrderFlag(this.isFirstOrder);
          } else {
            // No order data returned for logged-in user - assume NOT first order for safety
            this.isFirstOrder = false;
            this.orderService.setFirstOrderFlag(false);
          }
        },
        () => {
          // On error, don't apply first order discount to be safe
          this.isFirstOrder = false;
          this.orderService.setFirstOrderFlag(false);
        }
      );
      return;
    }

    // No CustomerId means new customer being created during checkout - this IS their first order
    this.isFirstOrder = true;
    this.orderService.setFirstOrderFlag(true);
  }
}

